<template>
  <div class="home">
    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">
        <video
          ref="video"
          class="video"
          preload="auto"
          muted
          loop
          playsinline
          autoplay
          poster="@/assets/video/company1.mp4"
          src="@/assets/video/company1.mp4"
          tabindex="-1"
        ></video>
      </div>
      <h1 class="banner-title">
        只听对的 用户至上 成就他人
        <div class="subTitle">JOIN US</div>
      </h1>
      <div class="bottom-tips">
        <span class="arrow-down" @click="scrollDown">
          <i>⤓</i>
        </span>
        <span class="vertical-dashed"></span>
      </div>
    </div>

    <!-- 产品 -->
    <div class="main">
      <div
        ref="product"
        class="product content-item-block animate__animated animate__slideInUp"
      >
        <h1 class="title ">
          Inspire creativity, enrich life
        </h1>
        <div class="desc  ">
          做鞋服仓配行业的领导者
        </div>
      </div>
      <!-- 产品 -->
      <div class="job-category content-item-block">
        <h2
          class="job-category-title title animate__animated animate__slideInUp"
        >
          公司产品
        </h2>
        <ul class="job-category-list clearfix">
          <li
            v-for="item in jobCategories"
            :key="item.id"
            class="job-category-item"
          >
            <router-link
              :to="{ name: 'products', params: { job_category_id: item.id } }"
            >
              <div class="image" :style="`backgroundImage:url(${item.image})`">
                <span class="overlay" v-if="!item.id">{{ item.zh_name }}</span>
              </div>
              <div v-if="item.id" class="name">{{ item.zh_name }}</div>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 员工故事 -->
      <div class="staffStory content-item-block">
        <h2 class="title">员工故事</h2>
        <ul class="staffStory-list clearfix">
          <router-link
            tag="li"
            :to="{ name: 'products' }"
            v-for="item in staffStories"
            :key="item.id"
            class="staffStory-item"
          >
            <div class="avatar">
              <img width="100%" :src="item.avatar" alt srcset />
            </div>
            <div class="text">
              <h2 class="title">{{ item.title }}</h2>
              <div class="desc">
                {{ item.name }}&nbsp;|&nbsp;{{ item.department }}
              </div>
              <p class="remark">{{ item.remark }}</p>
            </div>
            <div class="circular-button">→</div>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
// import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  name: "home",
  components: {
    // videoPlayer,
  },
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      jobCategories: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: [],
      playerOptions: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "@/assets/video/company1.mp4", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          currentTimeDisplay: true, // 当前时间
          volumeControl: true, // 声音控制键
          progressControl: false, // 进度条
          playToggle: false, // 暂停-播放 按钮
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      },
    };
  },
  created() {
    //之后接口请求这么写
    // const fetchProducts = this.request
    //   .get("/products")
    //   .then(response => {
    //     this.products = response;
    //   })
    //   .catch();
    this.jobCategories = [
      {
        en_name: "warehousing",
        id: "1",
        image: require("@/assets/image/warehousing.jpg"),
        zh_name: "仓储管理",
      },
      {
        en_name: "support",
        id: "2",
        image: require("@/assets/image/support.jpg"),
        zh_name: "系统支持",
      },
      {
        en_name: "distribution",
        id: "3",
        image: require("@/assets/image/distribution.jpg"),
        zh_name: "配送服务",
      },
      {
        en_name: "cutService",
        id: "4",
        image: require("@/assets/image/cutService.jpg"),
        zh_name: "客服服务",
      },
      {
        en_name: "valueAdded",
        id: "5",
        image: require("@/assets/image/valueAdded.jpg"),
        zh_name: "增值服务",
      },
      {
        en_name: "whole",
        id: "6",
        image: require("@/assets/image/whole.jpg"),
        zh_name: "全部",
      },
    ];
    this.staffStories = [
      // {
      //   avatar: require("@/assets/image/lipeilong.jpg"),
      //   title: "全能王",
      //   name: "李培龙",
      //   department: "项目四部",
      //   remark:
      //     "工作中积极严谨，生活中开朗活泼。始终坚信：成功就要不断尝试，不管过程是否艰辛，努力过后终有回报！",
      // },
      // {
      //   avatar: require("@/assets/image/wanghaiyan.jpg"),
      //   name: "王海燕",
      //   title: "小能手",
      //   department: "项目一部",
      //   remark:
      //     "一位业务能力扎实，工作认真积极严谨的物流人，也是一名出彩的带教导师。主动带教新同事，耐心倾听并提供建议，帮助伙伴更快融入团队，入职至今历任不同岗位，在工作岗位兢兢业业。",
      // },
      // {
      //   avatar: require("@/assets/image/lidandan.jpg"),
      //   name: "李丹丹",
      //   title: "标兵",
      //   department: "项目一部",
      //   remark: "棒棒",
      // },
      // {
      //   avatar: require("@/assets/image/xiaojicheng.jpg"),
      //   name: "肖继承",
      //   title: "技术之心",
      //   department: "项目一部",
      //   remark: "棒棒",
      // },
    ];
  },
  mounted() {},
  methods: {
    scrollDown() {
      this.$refs.product.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },

    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },
    onPlayerReadied() {},
    onTimeupdate() {},
  },
  mounted() {
    const rootVm = this.$root;
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
  },
  destroyed() {
    this.unwatch();
  },
};
</script>

<style lang="less" scoped>
@keyframes verticalMotion {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(6px);
  }
}
@keyframes scrollToRight {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}

.home {
  .main {
    width: @main-width;
    margin: auto;
  }
  .content-item-block {
    .title {
      font-size: @font-size-larger;
    }
  }
}

.banner {
  height: 100vh;
  min-height: 400px;
  min-width: @main-width;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(51, 112, 255, 0.2);
  position: relative;
  .video-wrapper {
    font-size: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    .video {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    color: #fff;
    font-size: 60px;
    text-align: center;
    .subTitle {
      &::after,
      &::before {
        content: "";
        position: absolute;
        background-image: linear-gradient(
          270deg,
          hsla(0, 0%, 100%, 0),
          #fff 47%,
          hsla(0, 0%, 100%, 0)
        );
        height: 2px;
        width: 89px;
        top: 50%;
        transform: translateY(-50%);
      }
      &:before {
        right: 10px;
      }
      &:after {
        left: 10px;
      }
      position: relative;
      margin-top: 10px;
      font-size: @font-size-base;
      letter-spacing: 20px;
    }
  }
  .search {
    width: 500px;
    margin-top: 100px;
    margin-bottom: 40px;
  }
  .bottom-tips {
    position: absolute;
    bottom: 30px;
    width: 50px;
    height: 50px;
    flex-shrink: 0;

    text-align: center;
    .arrow-down {
      display: block;
      margin-bottom: 4px;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 1px solid #fff;
      text-align: center;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
      font-size: 21px;
      i {
        animation: verticalMotion 1.3s infinite linear;
        display: inline-block;
        font-style: normal;
      }
    }
    // 分割竖线
    .vertical-dashed {
      border-left: 1px dashed #fff;
      height: 30px;

      display: inline-block;
    }
  }
}

// 产品
.product {
  margin-top: 40px;
  text-align: center;
  padding: 40px 40px;
  background: url(//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/mainland/global.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 370px;
  .desc {
    margin: 40px 0;
  }
  &-list {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  &-item {
    width: 90px;
    // height: 90px;
    cursor: pointer;
    &:nth-child(1),
    &:nth-child(9) {
      margin-top: 116px;
    }
    &:nth-child(2),
    &:nth-child(8) {
      margin-top: 80px;
    }
    &:nth-child(3),
    &:nth-child(7) {
      margin-top: 55px;
    }
    &:nth-child(4),
    &:nth-child(6) {
      margin-top: 30px;
    }
    &:hover {
      color: @main-color;
      img {
        border-radius: 19px;
        transform: scale(1.2);
        transform-origin: bottom;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      }
    }
    img {
      width: 90px;
      height: 90px;
      border-radius: 19px;
      margin-bottom: 10px;
      transition: transform 0.3s;
    }
  }
  .more {
    margin: auto;
    margin-top: 170px;

    width: 149px;
  }
}

// 职位

.job-category {
  text-align: center;
  margin-top: 90px;

  &-list {
    margin: 70px 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  &-item {
    margin: 0 auto;
    flex: 0 0 26%;
    margin-bottom: 16px;

    // box-shadow: 1px 1px rgba(0, 0, 0, 0);
    .image {
      width: 250px;
      height: 250px;
      line-height: 250px;
      background-repeat: no-repeat;
      background-size: 100%;
      border-radius: 50%;
      margin: 0 auto;
      transition: all 0.3s;
      background-position: center;
      overflow: hidden;
      &:hover {
        box-shadow: 0 0 8px 3px #ccc;
        background-size: 120%;
        & + .name {
          color: @main-color;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
      .overlay {
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;
        font-size: 40px;
      }
    }
    .name {
      margin-top: 23px;
      font-size: @font-size-large;
    }
    margin: 0 2.5%;
    margin-bottom: 30px;
    width: 20%;
  }
}

// 字节范

.byteStandard {
  padding: 40px 40px;
  overflow: hidden;
  .title {
    margin-bottom: 30px;
  }
  .desc {
    margin-bottom: 40px;
  }
  .content {
    .image {
      .layer {
        // left: -100%;
        width: 100%;
        top: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        position: absolute;
        animation: scrollToRight 0.8s ease-in-out;
      }

      position: relative;
      float: left;
      width: 700px;
      height: 450px;
      margin-right: 100px;
      overflow: hidden;
      img {
        border-radius: 6px;
        object-fit: cover;
      }
    }
  }
  .indicator {
    color: #aaa;

    &-item {
      margin: 32px 0;
      h3 {
        &.active {
          color: black;
          font-size: 32px;
          font-weight: 400;
        }
        cursor: pointer;
      }
    }
  }
}
// 字节生活
.byteLife {
  // width:1200px;
  // overflow: hidden;
  &-title {
    margin-bottom: 70px;
  }
  padding-left: 10%;
  .block-item {
    overflow: hidden;
    margin-bottom: 100px;
    &:nth-child(odd) {
      .block-item-column {
        &-text {
          margin-right: 9%;
        }
        float: left;
      }
    }
    &:nth-child(even) {
      .block-item-column {
        &-image {
          margin-right: 9%;
        }
        float: right;
      }
    }

    &-column {
      &-title {
        margin-bottom: 40px;
        padding-bottom: 40px;
        border-bottom: 1px solid #ccc;
      }
      &-text {
        width: 30%;
      }
      &-image {
        height: 400px;
        width: 59%;
        border-radius: 8px;
        overflow: hidden;
        img {
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
// 员工故事
.staffStory {
  padding: 0 140px;
  .title {
    text-align: center;
    margin-bottom: 10px;
  }

  &-list {
    text-align: center;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  &-item {
    // height: 450px;
    overflow: hidden;
    padding: 30px;
    width: 30%;
    cursor: pointer;

    &:hover {
      box-shadow: 0 10px 30px 0 @box-shadow-hover-color;
      .circular-button {
        color: @main-color;
      }
    }
    .avatar {
      width: 70%;
      margin: auto;
      border-radius: 50%;
      &:hover {
        transform: scale(1.1);
      }
    }
    .text {
      .title {
        color: @primary-text-color;
        font-weight: @font-weight-regular;
        font-size: @font-size-large;
        margin: 10px 0;
        white-space: nowrap;
      }
      .desc {
        color: @primary-text-color;
        margin: 12px 0;
        font-size: @font-size-base;
      }
      .remark {
        font-size: @font-size-base;

        color: @regular-text-color;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .circular-button {
      border-radius: 50%;
      width: 30px;
      height: 30px;
      border: 1px solid;
      line-height: 30px;

      margin: auto;
      margin-top: 20px;
      color: #ccc;
    }
  }
}
</style>
